import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { environment } from '../environments/environment';

export class ApiTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string): Observable<any> {
    return this.http
      .post<any>(`${environment.baseUrl}/get-active-languages`, {})
      .pipe(
        switchMap((res: any) => {
          const match = (res.languages || []).find((l: any) => l.language_code === lang);
          if (!match) throw new Error(`Language '${lang}' not found`);
          return this.http
            .post<any>(`${environment.baseUrl}/get-language`, { language_content_id: match.language_content_id })
            .pipe(map((r: any) => r.data));
        }),
        catchError(() => this.http.get<any>(`./assets/i18n/${lang}.json`))
      );
  }
}
